// extracted by mini-css-extract-plugin
export default {"table":"iVkKyQTJmpJKqW1mTKZc","countdown":"OFWNidJAXqhTsAxQDsSA","reviewAction":"G9U5Vtc8a0xni6rJ_PkZ"};